import React, {useState} from 'react'
import PropTypes from "prop-types";
import GeneralInfoExpansionPanelTitle from "./GeneralInfoExpansionPanelTitle";
import Tr from "translations/Translations";
import ExpansionPanel from "components/ExpansionPanel";
import formatAmountNumber from "libs/formatAmountNumber";
import moment from "moment";
import DateFormats from "constants/DateFormats";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import {makeStyles} from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
    buttonRow: {
        marginTop: theme.spacing(2),
        textAlign: "end"
    },
    lpColumn: theme.components.table.lpColumn,
    ipColumn: theme.components.table.ipColumn,
    dateColumn: theme.components.table.dateColumn
}));

function GeneralInfoRealizationAmount(
    {
        panelsClassesObject,
        generalInfoBasicData
    }) {

    const classes = useStyle();
    const [expanded, setExpanded] = useState(false);



    return (
        (!!generalInfoBasicData.realizationList && generalInfoBasicData.realizationList.length > 0) ?
        <ExpansionPanel
            classesObj={panelsClassesObject}
            title={
                <GeneralInfoExpansionPanelTitle
                    subject={Tr("realization_demand_value")}
                    toggleThread={() => setExpanded(x => !x)}
                    expanded={expanded}
                />
            }
            expanded={expanded}
            onChange={(e, isExpanded) => setExpanded(isExpanded)}

        >
            <SimpleTable
                columnClasses={[
                    undefined,
                    classes.dateColumn,
                    classes.dateColumn,
                ]}
                headers={[Tr('name'), Tr('gross_value'), Tr('publish_data')]}
                items={generalInfoBasicData.realizationList.map((item, index) => [
                    `${Tr('part_x', {x: item.ordinalNumber})}: ${item.name}`,
                    `${formatAmountNumber(item.value)} PLN`,
                    item.publishDate ? moment(item.publishDate).format(DateFormats.DATETIME_FORMAT) : ''
                ])}
            />
        </ExpansionPanel>
            :
            null
    )
}

GeneralInfoRealizationAmount.propTypes = {
    generalInfoBasicData: PropTypes.object.isRequired
}

export default GeneralInfoRealizationAmount;